export let formal =`
<div>
<p class="ql-align-center" style="text-align: center !important;"><em>RESTRICTED</em></p>

<div class="ql-align-center">
<h3><p>Headquarters </p>
<p>Training Command </p>
<p>Nigerian Airforce</p> <p>Kaduna</p>
</h3>
</div>
TC/NAF/37/TRG  							

<div class="ql-align-center">
<h3><p>062 233514  Extension 32 </p>
</h3>
</div>

<p>
<p>The Air Officer Commanding   </p>
<p>Training Command </p>
<p>Nigerian Airforce</p>
<p>KADUNA </p>

<div class="ql-align-center">
<h3><p style='color:red'>June 2013</p>
</h3>
</div>


<div>

Sir  (1)

<p><u><strong>REINSTATEMENT AS MEMBER OF AIR POWER DEMONSTRATION SQUADRON LEADER BB ADO </u></strong></p><br>

<p>1.	 I have the honour to request you reconsider your decision communicated in your letter TC/NAF/37/TRG dated 21 April 2013.  You directed that my name should be withdrawn from the list of pilots participating in this year's Air Power Demonstration for the Armed Forces Command and Staff College.  The reasons given were my age and my state of health.  .
</p><br>
<p>2. I would admit that at about the time of last year’s demonstration and immediately thereafter, my state of health was poor and this contributed to the near crash in which I was involved at the demonstration.  However, I regained currency on F-7 some 6 months ago and have been flying in those aircraft regularly with success.</p>
<br>
<p>3. I would submit therefore, that the reasons given for my being dropped are not valid, given that the medical authorities have cleared me and I have regained currency and achieved high levels of performance on a combat aircraft.  The question of age should not form part of the argument as a pilot's ability should be judged on his performance and medical fitness.</p>
<br>
<p>4. I appeal to you therefore, on the basis of the facts I have put before you, to reconsider your decision and reinstate me as a member of the demonstration team participating in this year's air power demonstration.</p>
</div><br>

<div class="ql-align-center">


<h3>
<p>I have the honour to be,</p>
<p>Sir,</p>
<p>Yours obedient officer</p>
<br>
<p style="color:red">BB ADO</p>
<p>Squadron Leader</p>
<p>Staff Officer 2 Operations</p>
</h3>


</div>
</p>






<p class="ql-align-justify" style="text-align: center;"><em style='color: rgb(0, 0, 0); font-family: "Times New Roman"; font-size: medium; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;'>RESTRICTED</em>&nbsp;</p>

</div>

`